import React from 'react';
import PropTypes from 'prop-types';

export function LoginBackButton({ goBack }) {
    return <i className="login-back-button icon icon-alan-chevron-fat"
        onClick={goBack} />;
}

LoginBackButton.propTypes = {
    goBack: PropTypes.func.isRequired,
};

export default LoginBackButton;
